import React from "react";

import { cn } from "../lib/utils";
import { STATE_DOT_TW, STATE_TW } from "../lib/colors";
import type { State } from "../types/boxes";

/** Colored chip showing one of UP / SCANNER_ONLY / CAMERA_ONLY / DOWN / POWERED_DOWN / UNKNOWN. */
export const StateBadge: React.FC<{ state: State; className?: string }> = ({
  state,
  className,
}) => (
  <span
    className={cn(
      "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-xs font-semibold",
      STATE_TW[state],
      className,
    )}
  >
    <span
      aria-hidden="true"
      className={cn("inline-block h-1.5 w-1.5 rounded-full", STATE_DOT_TW[state])}
    />
    {state}
  </span>
);

export default StateBadge;
